import { useCallback } from "react";
import { CellValueChangedEvent } from "ag-grid-community";
import { HRM3040_R01ServiceAllowDto, HRM3040_R01PositionAllowDto } from "../Dto_HRM3040_R01";

/** 같은 타입 T의 행 교체 함수를 받아 두 그리드의 일반 셀 편집 처리를 공유한다. */
interface Props<T> {
    updateRow: (index: number, data: T) => void; // 편집된 그리드의 Store 행 교체 함수
}

/** 두 기준표 중 전달한 타입 T의 일반 셀 변경을 반영하는 훅이다. 기존 행은 수정 상태가 된다. */
export const useHRM3040_R01CellChange = <T extends HRM3040_R01ServiceAllowDto | HRM3040_R01PositionAllowDto>({ updateRow }: Props<T>) => {
    // 의존성은 그리드별 행 교체 함수이다.
    const handleCellChange = useCallback((event: CellValueChangedEvent<T>) => {
        // 구조 분해로 행·컬럼·새 값을 읽는다.
        const { data, colDef, newValue } = event;
        if (event.node.rowPinned || !data || !colDef.field) return;
        const field = colDef.field as keyof T; // 실제 DTO에 있는 편집 필드
        // 펼치기로 행을 복사한 뒤 바뀐 필드와 기존 행의 수정 여부를 반영한다.
        updateRow(data.valueIndex, { ...data, [field]: newValue, isModified: !data.inserted });
    }, [updateRow]);
    return { handleCellChange };
};
